import AddIcon from "@mui/icons-material/Add";
import { default as CancelIcon, default as CloseIcon } from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./Index.css";
import {
  Avatar,
  Badge,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridRowModes,
  GridToolbarContainer
} from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import { bodyTypes, fitnessLevels, lifeStyles, energyLevels, goals } from "./UserResources.js";
import customerDefaultImage from "../../assets/images/customlogo/image.png";
import uploadFileImage from "../../assets/images/logos/image.png";
import fireIcon from "../../assets/images/manageuserslogo/Calorie.png";
import clockIcon from "../../assets/images/manageuserslogo/clockicon.png";
import { FaCheckCircle } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});

const appColor = "#59D6DF";
const initialRows = [];
const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};

const ProgramDetailsModal = ({ open, onClose, details }) => {
  if (!details || details.length === 0) return null;
  const navigate = useNavigate();
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          overflow: "hidden",
          padding: 2
        }}
      >
        {/* Close Button */}
        <IconButton
          sx={{
            position: "absolute",
            top: -6,
            right: 0,
            color: "black"
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        {/* Scrollable Content */}
        <Box sx={{ maxHeight: "70vh", overflowY: "auto", paddingTop: 4 }}>
          <Grid container spacing={2}>
            {details.map((program) => (
              <Grid item xs={12} key={program._id}>
                {/* Program Card */}
                <Box
                  sx={{
                    position: "relative",
                    borderRadius: 4,
                    overflow: "hidden",
                    boxShadow: 2
                  }}
                  onClick={() => {
                    navigate(`/programs`, { state: program });
                  }}
                >
                  {/* Program Image */}
                  <Box
                    sx={{
                      height: 180,
                      backgroundImage: `url(${program.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                      padding: 2,
                      color: "white"
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
                        color: "#FFFFFF"
                      }}
                    >
                      {program.name}
                    </Typography>
                  </Box>

                  {/* Details */}
                  <Box sx={{ padding: 2, bgcolor: "white" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img src={`${clockIcon}`} height="25" width="25" />
                        <Typography sx={{ fontWeight: "bold" }}>{program.days} Days</Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img src={`${fireIcon}`} height="25" width="25" />
                        <Typography sx={{ fontWeight: "bold" }}> {program.kcal} KCAL</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

const Users = () => {
  const [rows, setRows] = React.useState(initialRows);
  const [addedUser, setAddedUser] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [calledBlockUser, setCallBlockUser] = useState(false);
  const [profilePic, setProfilePic] = React.useState({});
  const [calledUpdateUser, setCallUpdateUser] = useState(false);
  const [searchBy, setSearchBy] = useState("");
  const [debouncedSearchBy, setDebouncedSearchBy] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProgramDetails, setSelectedPrgramDetails] = useState(null);

  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const { state } = useLocation();

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchBy(searchBy);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchBy]);

  // Reset pagination when search changes
  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [debouncedSearchBy]);

  const handleOpenModal = (details) => {
    setSelectedPrgramDetails(details);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedPrgramDetails(null);
    setModalOpen(false);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("token")}`
        };

        // Prepare request body with pagination and specific user ID if available
        const requestBody = {
          searchBy: debouncedSearchBy,
          page: paginationModel.page + 1, // API expects 1-based page numbers
          pageSize: paginationModel.pageSize
        };

        // Add specific user ID to request if available from state
        if (state?.id) {
          requestBody.specificUserId = state.id;
        }

        const userList = await axios.post(`${apiBaseURL}/api/v1/admin/getusers`, requestBody, {
          headers: headers
        });
        if (userList.data) {
          const { users, total, currentPage, totalPages } = userList.data.data;
          const currentRows = users.map((value, index) => {
            return {
              id: value?._id,
              profilePic: value?.profileImage
                ? `<img src="${value?.profileImage}" height="50" width="50"> `
                : `<img src="${apiBaseURL}/img/Profile.svg" height="50"> `,
              fullName: `${value?.firstName} ${value?.lastName}`,
              email: value?.email,
              isVerified: value?.isVerified,
              weight: value?.weight ? value?.weight : "Not added",
              height: value?.heightInFeet
                ? `${value?.heightInFeet}ft ${value?.heightInInch}Inch`
                : "Not added",
              bodyType: value?.bodyType ? bodyTypes[`${value?.bodyType}`] : "Not added",
              energyLevel: value?.energyLevel ? energyLevels[`${value?.energyLevel}`] : "Not added",
              lifeStyle: value?.lifeStyle ? lifeStyles[`${value?.lifeStyle}`] : "Not added",
              fitnessLevel: value?.fitnessLevel
                ? fitnessLevels[`${value?.fitnessLevel}`]
                : "Not added",
              goals: value?.goals ? goals[`${value?.goals}`] : "Not added",
              enrolledPrograms: value?.enrolledPrograms?.length
                ? value?.enrolledPrograms.map((value) => {
                    return value;
                  })
                : null,
              isBlocked:
                value?.isBlocked == false
                  ? `<button style="background-color:green; border: 1px solid transparent; height:40px; width:80px; font-size:20px; border-radius: 0.375rem; font-family:"Roboto","Helvetica","Arial",sans-serif; color:white; margin-top: 10px;">Block</button>`
                  : `<button style="background-color:#D22B2B;border: 1px solid transparent; height:40px; width:80px; font-size:18px; border-radius: 0.375rem;
                  font-family:"Roboto","Helvetica","Arial",sans-serif; color:white; margin-top: 10px;">Unblock</button>`
            };
          });
          setRows(currentRows);
          setTotalRows(total || users.length);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch users. Please try again."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [
    addedUser,
    calledBlockUser,
    calledUpdateUser,
    debouncedSearchBy,
    paginationModel.page,
    paginationModel.pageSize,
    state?.id
  ]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete this user?`,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: appColor
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const headers = {
              "Content-Type": "application/json",
              "x-access-token": `${localStorage.getItem("token")}`
            };
            const deleteUser = await axios.delete(`${apiBaseURL}/api/v1/admin/deleteuser`, {
              headers: headers,
              data: {
                id
              }
            });
            if (deleteUser.data) {
              Swal.fire("The user is deleted now!", "", "success");
              setRows(rows.filter((row) => row.id !== id));
            }
          } catch (error) {
            console.log(error, "error");
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  const handleBlockButton = (id, isBlocked) => {
    if (id) {
      Swal.fire({
        title: `Are you sure you want to ${isBlocked === true ? "unblock" : "block"} this user?`,
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: appColor
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const headers = {
                "Content-Type": "application/json",
                "x-access-token": `${localStorage.getItem("token")}`
              };
              const blockUser = await axios.delete(
                `${apiBaseURL}/api/v1/admin/deletepostandblockuser`,
                {
                  headers: headers,
                  data: {
                    postId: null,
                    userId: id,
                    blockUser: isBlocked
                  }
                }
              );
              if (blockUser.data) {
                Swal.fire(
                  `The user is ${isBlocked === true ? "unblocked" : "blocked"} now!`,
                  "",
                  "success"
                );
                setCallBlockUser(!calledBlockUser);
              }
            } catch (error) {
              console.log(error, "error in trycatch");
            }
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        })
        .catch((error) => {
          console.log(error, "error in thencatch");
        });
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const handleFileChange = (e, params) => {
    const file = e.target.files[0];
    if (file) {
      const updatedRow = {
        ...params.row,
        // profilePic: `<img src="${URL.createObjectURL(file)}" />`,?
        profilePic: file
      };
      setProfilePic(updatedRow.profilePic);
      setRows((prevRows) => prevRows.map((row) => (row.id === params.id ? updatedRow : row)));
    }
  };

  const columns = [
    {
      field: "profilePic",
      headerName: "Profile Pic",
      width: 200,
      sortable: false,
      type: "file",
      renderCell: (params) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: params.value // Render the HTML content (image tag)
            }}
          />
        );
      },
      renderEditCell: (params) => {
        return (
          <Box>
            <VisuallyHiddenInput
              id="picture"
              name="picture"
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, params)}
            />
            <IconButton
              aria-label="upload"
              sx={{
                border: "1px solid #F2F2F2",
                borderRadius: 2
              }}
              onClick={() => document.getElementById("picture").click()}
            >
              <img height="20" width="20" src={uploadFileImage} alt="upload icon" />
            </IconButton>
          </Box>
        );
      }
    },
    { field: "fullName", headerName: "Name", width: 200, sortable: false },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      type: "email",
      sortable: false
    },
    {
      field: "isVerified",
      headerName: "Email Verification Status",
      width: 200,
      sortable: false,
      renderCell: (params) =>
        params.row.isVerified ? (
          <IconButton>
            <FaCheckCircle />
          </IconButton>
        ) : (
          <IconButton>
            <ImCancelCircle />
          </IconButton>
        )
    },
    { field: "weight", headerName: "Weight(In LBS)", width: 200, type: "number", sortable: false },
    { field: "height", headerName: "Height", width: 200, sortable: false },
    {
      field: "bodyType",
      headerName: "Body Type",
      width: 200,
      type: "singleSelect",
      sortable: false,
      valueOptions: ["endomorph", "mesomorph", "ectomorph"]
    },
    {
      field: "energyLevel",
      headerName: "Energy Level",
      width: 200,
      type: "singleSelect",
      sortable: false,
      valueOptions: ["regular", "high", "low", "fatigued"]
    },
    {
      field: "lifeStyle",
      headerName: "Life Style",
      width: 200,
      type: "singleSelect",
      sortable: false,
      valueOptions: ["parent", "working student", "pregnant", "other"]
    },
    {
      field: "fitnessLevel",
      headerName: "Fitness Level",
      width: 200,
      type: "singleSelect",
      sortable: false,
      valueOptions: ["beginner", "intermediate", "advanced"]
    },
    {
      field: "goals",
      headerName: "Goal",
      width: 200,
      type: "singleSelect",
      sortable: false,
      valueOptions: ["lose weight", "gain muscle mass", "maintain physique"]
    },
    {
      field: "programs",
      headerName: "Enrolled Programs",
      sortable: false,
      width: 200,
      renderCell: (params) =>
        params.row.enrolledPrograms ? (
          <IconButton
            sx={{ left: -30 }}
            onClick={() => handleOpenModal(params.row.enrolledPrograms)}
          >
            <Button href="#text-buttons" style={{ textTransform: "none" }}>
              View Programs
            </Button>
          </IconButton>
        ) : (
          "N/A"
        )
    },
    {
      field: "actions",
      type: "actions",
      sortable: false,
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => {
              handleDeleteClick(id);
            }}
            color="inherit"
          />
        ];
      }
    },
    {
      field: "isBlocked",
      headerName: "Block/Unblock",
      width: 200,
      type: "button",
      sortable: false,
      cellClassName: "actions",
      renderCell: (params) => {
        const { id, isBlocked } = params.row;
        const blocked = isBlocked.includes("Unblock");
        return (
          <div
            onClick={() => {
              handleBlockButton(id, blocked);
            }}
            dangerouslySetInnerHTML={{
              __html: params.value // Render the HTML content (image tag)
            }}
            style={{ width: "fit-content", marginTop: "5px" }}
          />
        );
      }
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ width: "100%", marginBottom: 2 }}>
        <TextField
          id="outlined-basic"
          label="Search by Name or Email"
          variant="outlined"
          value={searchBy}
          onChange={(event) => {
            setSearchBy(event.target.value);
          }}
          sx={{
            width: "300px"
          }}
        />
      </Box>
      <Box
        sx={{
          height: 675,
          width: "100%",
          "& .actions": {
            color: "text.secondary"
          },
          "& .textPrimary": {
            color: "text.primary"
          }
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnResize
          disableColumnMenu
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          onRowEditStop={handleRowEditStop}
          localeText={{ noRowsLabel: "No User is available" }}
          // Server-side pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={totalRows}
          pageSizeOptions={[10, 20, 30, 50]}
          loading={loading}
          sx={{
            fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
            fontWeight: 400,
            "& .MuiDataGrid-columnHeader": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#fff",
              "&:nth-of-type(odd)": {
                backgroundColor: "#f9f9f9"
              }
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-row:focus": {
              outline: "none"
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none"
            },
            "& .Mui-selected": {
              backgroundColor: "inherit !important"
            },
            "& .MuiDataGrid-columnHeader": {
              "& .MuiDataGrid-iconButtonContainer": {
                display: "none"
              },
              "& .MuiDataGrid-menuIcon": {
                display: "none"
              }
            }
          }}
          slotProps={{
            toolbar: { setRows, setRowModesModel, addedUser, setAddedUser }
          }}
        />
        <ProgramDetailsModal
          open={modalOpen}
          onClose={handleCloseModal}
          details={selectedProgramDetails}
        />
      </Box>
    </DashboardLayout>
  );
};

export default Users;
